export const SET_ACTIVE_USER_SUBSCRIPTIONS = 'SET_ACTIVE_USER_SUBSCRIPTIONS';

export const setActiveUserSubscriptions = ({ subscriptions }) => ({
  type: SET_ACTIVE_USER_SUBSCRIPTIONS,
  payload: {
    subscriptions
  }
});
